import { WareHouseActionTypes } from './constants';

const GET_WAREHOUSE_DATA_INITIAL_STATE = {
    wareHouseData: [],
    loading: false,
};
const CREATE_WAREHOUSE_DATA_INITIAL_STATE = {
    createWareHouseData: [],
    loading: false,
};

const UPDATE_WAREHOUSE_DATA_INITIAL_STATE = {
    updateWarehouseData: [],
    loading: false,
};
const DELETE_WAREHOUSE_DATA_INITIAL_STATE = {
    deleteWarehouseData: [],
    loading: false,
};

const UPLOAD_WAREHOUSE_DATA_INITIAL_STATE = {
    uploadWareHouseData: [],
    loading: false,
};

const wareHouseDataReducer = (state = GET_WAREHOUSE_DATA_INITIAL_STATE, action) => {
    switch (action.type) {
        case WareHouseActionTypes.WAREHOUSE_DATA_LOADING:
            return {
                wareHouseData: state.wareHouseData,
                loading: true,
            };
        case WareHouseActionTypes.WAREHOUSE_DATA_SUCCESS:
            return {
                wareHouseData: action.payload,
                loading: false,
            };
        case WareHouseActionTypes.WAREHOUSE_DATA_ERROR:
            return {
                wareHouseData: action.payload,
                loading: false,
            };
        default:
            return state;
    }
};
const createWareHouseDataReducer = (state = CREATE_WAREHOUSE_DATA_INITIAL_STATE, action) => {
    switch (action.type) {
        case WareHouseActionTypes.CREATE_WAREHOUSE_DATA_LOADING:
            return {
                createWareHouseData: state.createWareHouseData,
                loading: true,
            };
        case WareHouseActionTypes.CREATE_WAREHOUSE_DATA_SUCCESS:
            return {
                createWareHouseData: action.payload,
                loading: false,
            };
        case WareHouseActionTypes.CREATE_WAREHOUSE_DATA_ERROR:
            return {
                createWareHouseData: action.payload ,
                loading: false,
            };
        case WareHouseActionTypes.STATE_EMPTY_FIRST:
            return { ...CREATE_WAREHOUSE_DATA_INITIAL_STATE };
        default:
            return state;
    }
};
const updateWarehouseDataReducer = (state = UPDATE_WAREHOUSE_DATA_INITIAL_STATE, action) => {
    switch (action.type) {
        case WareHouseActionTypes.UPDATE_WAREHOUSE_DATA_LOADING:
            return {
                updateWarehouseData: action.payload,
                loading: true,
            };
        case WareHouseActionTypes.UPDATE_WAREHOUSE_DATA_SUCCESS:
            return {
                updateWarehouseData: action.payload,
                loading: false,
            };
        case WareHouseActionTypes.UPDATE_WAREHOUSE_DATA_ERROR:
            return {
                updateWarehouseData: action.payload ,
                loading: false,
            };
        case WareHouseActionTypes.STATE_EMPTY_FIRST:
            return { ...UPDATE_WAREHOUSE_DATA_INITIAL_STATE };
        default:
            return state;
    }
};
const deleteWarehouseDataReducer = (state = DELETE_WAREHOUSE_DATA_INITIAL_STATE, action) => {
    switch (action.type) {
        case WareHouseActionTypes.DELETE_WAREHOUSE_DATA_LOADING:
            return {
                deleteWarehouseData: action.payload,
                loading: true,
            };
        case WareHouseActionTypes.DELETE_WAREHOUSE_DATA_SUCCESS:
            return {
                deleteWarehouseData: action.payload,
                loading: false,
            };
        case WareHouseActionTypes.DELETE_WAREHOUSE_DATA_ERROR:
            return {
                deleteWarehouseData: action.payload ,
                loading: false,
            };
        case WareHouseActionTypes.STATE_EMPTY_FIRST:
            return { ...DELETE_WAREHOUSE_DATA_INITIAL_STATE };
        default:
            return state;
    }
};
const uploadWareHouseDataReducer = (state = UPLOAD_WAREHOUSE_DATA_INITIAL_STATE, action) => {
    switch (action.type) {
        case WareHouseActionTypes.UPLOAD_WAREHOUSE_DATA_LOADING:
            return {
                uploadWareHouseData: state.uploadWareHouseData,
                loading: true,
            };
        case WareHouseActionTypes.UPLOAD_WAREHOUSE_DATA_SUCCESS:
            return {
                uploadWareHouseData: action.payload,
                loading: false,
            };
        case WareHouseActionTypes.UPLOAD_WAREHOUSE_DATA_ERROR:
            return {
                uploadWareHouseData: action.payload ,
                loading: false,
            };
        case WareHouseActionTypes.STATE_EMPTY_FIRST:
            return { ...UPLOAD_WAREHOUSE_DATA_INITIAL_STATE };
        default:
            return state;
    }
};

export { wareHouseDataReducer, createWareHouseDataReducer, updateWarehouseDataReducer, deleteWarehouseDataReducer, uploadWareHouseDataReducer };
